import {takeLatest, put} from 'redux-saga/effects';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  VERIFY_OPT,
  VERIFY_OPT_SUCCESS,
  VERIFY_OPT_FAILED,
  GENERATE_OPT,
  GENERATE_OPT_SUCCESS,
  GENERATE_OPT_FAILED,
} from './constants';

import {
  AuthenticationRequestBuilder,
  OptAuthenticationRequestBuilder,
  OptGenerateRequestBuilder,
} from 'client-sdk/src/authentication/authentication';
import Client from 'client-sdk/src/client';
import {Actions} from './interfaces';
import handleNotfication from '../../utils/handleNotification';
import {handleRedirectByRule} from '../../utils/helpers';
import loginRepository from "client-sdk/src/Repository/login-repository";

const token = localStorage.getItem('token') || '';
export function* authentication(action: Actions): any {
  try {
    const response = yield loginRepository.authentication(action);
    if (
        response.data.role == "WAREHOUSE_OPERATOR" ||
        response.data.role == "WAREHOUSE_ADMIN" ||
        response.data.role == "WAREHOUSE_SUPERVISOR"||
        response.data.role == "EXCHANGE_ADMIN" 
    ) {
        yield put({
            type: LOGIN_SUCCESS,
            data: response.data
        });
        window.location.pathname !== "/login"
            ? window.location.reload()
            : handleRedirectByRule(response.data.role);
    } else {
        yield put({
            type: LOGIN_FAILED,
            error: "not-for-warehouse"
        });
    }
  } catch (error) {
    yield put({
      type: LOGIN_FAILED,
      error: error.message,
    });
  }
}

export function* generateOpt(action: any): any {

  try {
    const { response, callback } = yield loginRepository.generateOpt(action);
    yield put({
      type: GENERATE_OPT_SUCCESS,
      data: response.data,
    });
    callback();
  } catch (error) {
    yield put({
      type: GENERATE_OPT_FAILED,
      error: error.message,
    });
  }
}

export function* verifyOpt(action: any): any {
  try {
    const response = yield loginRepository.verifyOpt(action);
    yield put({
      type: VERIFY_OPT_SUCCESS,
      data: response.data,
    });
    handleNotfication('ورود با موفقیت انجام شد', 'success');
    window.location.pathname !== '/login'
      ? window.location.reload()
      : (window.location.href = '/orders');
  } catch (error) {
    yield put({
      type: VERIFY_OPT_FAILED,
      error: error.message,
    });
  }
}

export default function* loginSaga() {
  yield takeLatest(LOGIN, authentication);
  yield takeLatest(VERIFY_OPT, verifyOpt);
  yield takeLatest(GENERATE_OPT, generateOpt);
}
